module.exports = __webpack_public_path__ + "assets/img/ab5-6.b671abec.png";